<template>
  <div class="modal fade" id="modal-delete-account" tabindex="-1" role="dialog"
       aria-labelledby="modal-delete-account-title" aria-hidden="true" data-backdrop="static">
    <div class="modal-dialog modal-dialog-centered" role="document">      
      <div class="modal-content">
        <div class="modal-header">
          <h4 v-if="state === 'confirm'" class="modal-title" id="modal-delete-account-title">Delete Your Account?</h4>
          <h4 v-else class="modal-title" id="modal-delete-account-title">Account Deletion Pending</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" v-if="state === 'confirm'">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div v-if="state === 'confirm'" class="d-flex align-items-center">
            <i class="fa fa-exclamation-circle text-danger fa-3x"></i>
            <div class="ml-3">
              <p class="m-0">
                Your request will be processed within a few hours, and once completed, your account cannot be restored.
              </p>
            </div>
          </div>
          <div v-else class="d-flex align-items-start">
            <i class="fa fa-check-circle fa-3x text-warning mt-1"></i>
            <div class="ml-3">
              <p class="m-0">We have received your request to delete your account.</p>
              <p class="m-0 mt-2">It will be processed and completed within several hours.
                During this time, the deletion can still be reversed.
                To cancel the deletion, please contact us immediately at <a :href="`mailto:${emails.CONTACT}`" class="modal-delete-account-email">{{emails.CONTACT}}</a></p>
            </div>
          </div>
        </div>
        <div class="modal-footer" v-if="state === 'confirm'">
          <button type="button" class="btn btn-secondary btn-cancel" data-dismiss="modal" tabindex="1">Cancel</button>
          <BtnSubmit class="ml-auto" :title="'Yes, delete my account'" :spinner="true" :submitHandler="deleteAccount" />
        </div>
        <div class="modal-footer" v-else>
          <button type="button" class="btn btn-secondary ml-auto" @click="logout" tabindex="1">Sign Out</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {Component, Vue} from 'vue-facing-decorator';
import {handleXhrError} from '../utils/Ui';
import {UserDelete} from '../Routes';
import BtnSubmit from './BtnSubmit.vue';
import {signOut} from '../auth/Auth';

import $ from 'jquery';

type State = 'confirm' | 'done';

@Component({
  components: { BtnSubmit }
})
export default class AccountDeleteModal extends Vue {
  private state: State = 'confirm';

  private emails = {
    CONTACT: "contact@ganttproject.cloud"
  }

  public show() {
    this.state = 'confirm';
    $('#modal-delete-account').modal('show');
  }
  public hide() {
    $('#modal-delete-account').modal('hide');
  }
  public deleteAccount(): JQueryPromise<any> {
    return UserDelete.invoke(undefined)
      .then(() => {
        this.state = 'done';
      })
      .fail((jqXhr) => handleXhrError(jqXhr, 'Error has occurred while deleting account'));
  }
  public logout() {
    signOut();
  }
}
</script>

<style lang="scss" scoped>
@import "sass/components/variables";

.modal-delete-account-email {
  text-decoration: none;
  
  &:hover {
    text-decoration: underline;
  }
}
</style>


